import { Icon } from "@iconify/react";
import _ from "lodash";
import Markdown from "react-markdown";
import { Copier } from "../../helpers/Copier";

interface Message {
  chat_session_uid: string;
  id?: string;
  content: string;
  role: "user" | "assistant";
  timestamp: Date;
}

type UserMessageProps = {
  message: Message;
};

export function UserMessage({ message }: UserMessageProps) {
  return (
    <div className="grid justify-items-end auto-rows-max">
      <div className="min-w-[30%] max-w-[80%] rounded-lg p-2 bg-blue-400 text-white">
        <span className="text-xs opacity-70 mb-1 grid grid-cols-[1fr_auto] bg-blue-500 rounded-lg p-2">
          <span className="flex items-center gap-1">
            <Icon icon="heroicons:user" className="w-5 h-5" />
            {_.capitalize(message.role)}
          </span>
          <Copier content={message.content} />
        </span>
        <p className="whitespace-normal [&_li]:list-disc [&_li]:ml-6 p-2">
          <Markdown disallowedElements={["h1", "h2", "h3", "h4"]}>{message.content}</Markdown>
        </p>
        <span className="text-xs opacity-70 mt-1 block text-right font-bold">
          {message.timestamp.toLocaleTimeString()}
        </span>
      </div>
    </div>
  );
}
